export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const SHIPPING_TRACKING = 'SHIPPING_TRACKING'
